import { useMemo } from "react";
import usePlanInfoStore from "@/store/zustand/planInfoStore";

export function useSubscriptionInfo() {
  const rawSubscriptionTier = usePlanInfoStore(
    (state) => state.subscriptionTier,
  );
  const currentPeriodEnd = usePlanInfoStore(
    (state) => state.current_period_end,
  );
  const promptPackages = usePlanInfoStore((state) => state.promptPackages);

  const subscriptionTier = useMemo(
    () => rawSubscriptionTier || "free",
    [rawSubscriptionTier],
  );

  const usingPrompts = useMemo(
    () =>
      rawSubscriptionTier === "free" ||
      !rawSubscriptionTier ||
      rawSubscriptionTier?.startsWith("new"),
    [rawSubscriptionTier],
  );

  const extraPromptsInPackages = useMemo(
    () =>
      promptPackages?.reduce(
        (acc, curr) => acc + (curr.num_prompts - curr.prompts_used),
        0,
      ) || 0,
    [promptPackages],
  );

  const renewDisplay = useMemo(() => {
    if (!currentPeriodEnd) {
      const nextMonth = new Date();
      nextMonth.setMonth(nextMonth.getMonth() + 1);
      nextMonth.setDate(1);
      return nextMonth.toLocaleString(undefined, {
        month: "long",
        day: "numeric",
      });
    }

    return currentPeriodEnd.toLocaleString(undefined, {
      month: "long",
      day: "numeric",
    });
  }, [currentPeriodEnd]);

  return {
    rawSubscriptionTier,
    subscriptionTier,
    usingPrompts,
    extraPromptsInPackages,
    renewDisplay,
    currentPeriodEnd,
  };
}
